import {
  formatPbiReviewFloorLabel,
  pbiReviewFloorFromThreshold,
  type PbiReviewThreshold,
} from "@/lib/pbi-review-floor"
import { questionSignalInputFromPaperRow } from "@/lib/question-preview-adapters"
import { questionNeedsReview } from "@/lib/question-signals"
import type { QuestionRecord } from "@/src/pages/assessment-details"

export type { PbiReviewThreshold } from "@/lib/pbi-review-floor"
export {
  PBI_REVIEW_FLOOR_DEFAULT,
  PBI_REVIEW_FLOOR_OPTIONS,
  PBI_REVIEW_FLOOR_PROGRAM,
  formatPbiReviewFloorLabel,
  isPbiReviewThreshold,
  normalizePbiReviewThreshold,
  pbiReviewFloorFromThreshold,
  pbiReviewFloorSummary,
  pbiReviewThresholdFromIndex,
  pbiReviewThresholdIndex,
} from "@/lib/pbi-review-floor"

export function paperQuestionNeedsReview(
  row: QuestionRecord,
  threshold: PbiReviewThreshold,
): boolean {
  return questionNeedsReview({
    ...questionSignalInputFromPaperRow(row),
    pbiReviewFloor: pbiReviewFloorFromThreshold(threshold),
  })
}

export function countPaperQuestionsNeedingReview(
  rows: QuestionRecord[],
  threshold: PbiReviewThreshold,
): number {
  return rows.filter(
    (row) => row.status !== "Draft" && paperQuestionNeedsReview(row, threshold),
  ).length
}

export function reviewFloorDisplay(threshold: PbiReviewThreshold): string {
  return formatPbiReviewFloorLabel(threshold)
}
